export const SCHEMA_ERROR_AT_SERVICE = 'SCHEMA_ERROR_AT_SERVICE'
export const SCHEMA_ERROR_FETCHING = 'SCHEMA_ERROR_FETCHING'
export const SCHEMA_ERROR_WRONG_FORMAT = 'SCHEMA_ERROR_WRONG_FORMAT'
export const SCHEMA_ERROR_PASSWORD = 'SCHEMA_ERROR_PASSWORD'
export const MISSING_PERMISSIONS = 'MISSING_PERMISSIONS'
